// extracted by mini-css-extract-plugin
export var container = "_8s-0";
export var containerTopRight = "_8s-1";